import React, { useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Link, SpaceBetween } from '@amzn/awsui-components-react-v3';

import { Context } from '../../../store';
import { containersType, Model, URIParams } from '../../../store/types';
import { CopyText } from '../../CopyText/CopyText';

interface ContainersCellProps {
  model: Model;
}

interface ContainerIdProps {
  onClick?: (id: string) => void;
  id: string;
}

const MINIMUM_CONTAINERS = 3;

const ContainerId = ({ onClick, id }: ContainerIdProps) => {
  const { state } = useContext(Context);
  const containersMap: containersType = state?.containers;
  const containerType = containersMap?.[id]?.type || containersMap?.[id];

  return (
    <SpaceBetween key={id} direction="horizontal" size="s">
      <CopyText label="container id" value={id}>
        {id}
      </CopyText>
      <Box variant="span" color="text-body-secondary">
        {containerType}
      </Box>
    </SpaceBetween>
  );
};

export const ContainersCell = ({ model }: ContainersCellProps) => {
  let history = useHistory();
  let { referenceId, receiveType } = useParams<URIParams>();
  const [viewMore] = useState(false);

  const onHandleClickViewMore = () => {
    history.push(`/receive/${receiveType}/${referenceId}/model/${model?.mpnIpnId}`);
  };

  const containerIds = model?.containerIds || [];
  const top3 = viewMore ? containerIds : containerIds?.slice(0, MINIMUM_CONTAINERS);

  return (
    <Box>
      {top3.map((id) => (
        <ContainerId key={id} id={id} />
      ))}
      {containerIds.length > 3 && (
        <Box variant="span">
          <Link onFollow={onHandleClickViewMore}>... {!viewMore ? 'view more' : 'view less'}</Link>
        </Box>
      )}
    </Box>
  );
};
